module.exports = __webpack_public_path__ + "img/calendar.665164ff.svg";